import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';
import type { UpdateChaConsentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/common';

export function useSaveChaConsent(): {
    saveChaConsent: (updateChaConsentDto: UpdateChaConsentDTO) => Promise<void>;
} {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const saveChaConsent = async (updateChaConsentDto: UpdateChaConsentDTO): Promise<void> => {
        await OnlineSales.saveChaConsent(jobNumber, updateChaConsentDto, sessionId);
    };

    return { saveChaConsent };
}
